import styled, { css } from 'styled-components';
import { TagContentStyledProps, TagStyledProps } from './Tag.typed';

export const Tag = styled.button<TagStyledProps>`
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px;
  // TODO: there shouldn't be margin on shared components so they can fit into any layout.
  // Let's re-add this margin to wherever it's needed in DealerHub and remove it here.
  margin-bottom: ${({ theme }) => theme.spacing.S2};
  min-width: 24px;
  height: 24px;
  overflow: hidden;
  text-align: center;
  border-radius: ${({ theme }) => theme.borderRadius.s};
  box-shadow: ${({ theme, elevated }) =>
    elevated ? theme.shadow.primary : 'none'};
  ${({ intent, theme }) => theme.components.tag.intent[intent]}

  ${({ clickable }) =>
    clickable &&
    css`
      // Creates a larger touch target when clickable
      &:before {
        position: absolute;
        z-index: 1;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        min-height: 40px;
        min-width: 40px;
        content: '';
        transform: translate(-50%, -50%);
      }
    `}
`;
export const Leading = styled.span`
  display: inline-flex;
`;
export const Trailing = styled.span`
  display: inline-flex;
`;
export const Content = styled.span<TagContentStyledProps>`
  flex: none;
  font-size: ${({ theme }) => theme.typography.fontSizes.S12};
  font-weight: ${({ theme, weight }) => theme.typography.fontWeights[weight]};
  line-height: ${({ theme }) => theme.typography.lineHeights.S16};
`;
